export default function LogIcon({ className = '', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* contorno do arquivo com canto dobrado */}
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* texto LOG centralizado na parte inferior do arquivo */}
      <text
        x="12"
        y="16"
        textAnchor="middle"
        fontSize="6"
        fontWeight="700"
        fill="currentColor"
        fontFamily="sans-serif"
      >
        LOG
      </text>
    </svg>
  );
}
